// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Core__Option from "@rescript/core/src/Core__Option.re.mjs";
import * as Core from "@linaria/core";
import * as JsxRuntime from "react/jsx-runtime";

import { cx } from '@linaria/core'
;

function UiAction(props) {
  var __active = props.active;
  var onClick = props.onClick;
  var active = __active !== undefined ? __active : false;
  var baseClass = active ? "italic" : "";
  return JsxRuntime.jsx("a", {
              children: props.children,
              className: Core__Option.getOr(Core__Option.map(props.className, (function (c) {
                          return Core.cx(c, baseClass);
                        })), baseClass),
              alt: props.alt,
              href: "#",
              onClick: (function (e) {
                  e.preventDefault();
                  onClick(e);
                }),
              onTouchStart: Core__Option.getOr(Core__Option.map(props.onTouchStart, (function (f) {
                          return function (e) {
                            e.preventDefault();
                            f(e);
                          };
                        })), (function (e) {
                      e.preventDefault();
                    }))
            });
}

var make = UiAction;

export {
  make ,
}
/*  Not a pure module */
